import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import { Guards } from 'interfaces/guards'
import { connectShadedLoadable, createParallelGuard } from 'helpers/loadableHelpers'
import { peergroupsGuard } from 'guards/globalGuards'
import { getMonthlyTrendChanges } from 'helpers/trendHelpers'
import VerticalBarChart, { VerticalBarChartProps } from 'components/features/pfm/VerticalBarChart/VerticalBarChart'
import { peergroupGenericTrendsGuard } from 'guards/genericGuards'
import { memberNetworthChangeGuard } from 'guards/networthGuards'
import { memberNetworthChangeSelector, yourPeersGenericTrendsSelector, othersGenericTrendsSelector } from 'selectors/genericSelectors'
import { selectedRelationSelector } from 'selectors/peergroupSelectors'
import { GenericTrendOwnProps } from 'interfaces/trend'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { withComparisonSelector } from 'components/features/pageFilters/selectors'

const createMapStateToProps = () =>
  createSelector(
    memberNetworthChangeSelector,
    yourPeersGenericTrendsSelector,
    othersGenericTrendsSelector,
    selectedRelationSelector,
    withComparisonSelector,
    (memberChange, peersTrend, otherTrend, selectedRelation, withComparison): VerticalBarChartProps => {
      if (!memberChange) {
        throw createForgottenGuardError('NetworthChangeModuleContainer', 'memberNetworthChangeGuard')
      }

      if (!peersTrend || !otherTrend) {
        throw createForgottenGuardError('NetworthChangeModuleContainer', 'peergroupGenericTrendsGuard')
      }

      const memberTrendChange = getMonthlyTrendChanges(memberChange.actual)
      const peersTrendChange = getMonthlyTrendChanges(peersTrend.actual)
      const otherTrendChange = getMonthlyTrendChanges(otherTrend.actual)

      return {
        values: {
          memberValue: memberTrendChange[0].amount,
          peerValue: peersTrendChange[0].amount,
          otherValue: otherTrendChange[0].amount,
        },
        options: {
          isCurrency: true,
        },
        othersName: selectedRelation ? selectedRelation.name : '',
        withComparison,
      }
    }
  ) as (state: State, ownProps: GenericTrendOwnProps) => VerticalBarChartProps

const guards: Guards<GenericTrendOwnProps> = [
  peergroupsGuard,
  createParallelGuard(
    memberNetworthChangeGuard,
    peergroupGenericTrendsGuard,
  ),
]

const NetworthChangeModuleContainer = connectShadedLoadable<
  VerticalBarChartProps,
  {},
  {},
  GenericTrendOwnProps
>(createMapStateToProps, undefined, guards)(VerticalBarChart)
export default NetworthChangeModuleContainer
